import { post } from '@classic/Foundation/Services/ApiService'
import { BetEnquiryResponseDataTransferObject } from '../DataTransferObjects/DataTransferObjects'
import type { ILegacyBetModel } from '../Model/ILegacyBetModel'

export function enquireBet(
  betViewModel: ILegacyBetModel
): Promise<BetEnquiryResponseDataTransferObject> {
  return post({ url: '/api/totebet/betcost', body: betViewModel })
}

export function enquireAllUpBet(
  betViewModelDto: ILegacyBetModel
): Promise<BetEnquiryResponseDataTransferObject> {
  return post({ url: '/api/totebet/betcostallup', body: betViewModelDto })
}
